<template>
  <panel>
    <div class="w-50 mx-auto text-right mb-2">
      <button class="btn btn-primary" aria-label="Dodaj wartość" @click="showAddModal">Dodaj</button>
    </div>

    <div class="table-responsive">
      <table class="mx-auto table table-bordered table-hover w-50 table-striped dataTable dtr-inline">
        <thead>
          <tr role="row">
            <th>
              Nazwa
            </th>

            <th>
              Wartość
            </th>

            <th />
          </tr>
        </thead>

        <tbody>
          <tr v-for="value in values" :key="`value_${value.id}`">
            <td>{{ documentValueTranslation(value.code) }}</td>

            <td>
              <span v-if="value.value.date">{{ value.value.date | moment('DD.MM.YYYY') }}</span>

              <span v-else-if="value.value.number">{{ value.value.number }}</span>

              <span v-else-if="isCustomValueCode(value.code)">
                {{ customValueSummary(value) }}
              </span>

              <span v-else-if="value.value.bool !== undefined">{{ boolean(value.value.bool) }}</span>

              <span v-else-if="isTextValueCode(value.code)">{{ value.value.text }}</span>
            </td>

            <td class="text-center">
              <check-permission permissions="DOCUMENT_VALUE.UPDATE" entity-type="documentValue" :entity-id="value.id">
                <tooltip text="Aktualizuj wartość">
                  <button
                    class="btn rounded-circle btn-icon btn-light mr-2"
                    aria-label="Aktualizuj wartość"
                    @click="showEditModal(value.id)"
                  >
                    <i aria-hidden="true" class="fal fa-fw fa-edit" />
                  </button>
                </tooltip>
              </check-permission>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <document-value-modal
      :id="idToEdit"
      :show="showModal"
      :codes="codes"
      @update="showConfirmModal($event)"
      @save="add"
      @close="hideModal"
    />

    <confirm-modal
      :show="confirmModalVisible"
      :text="confirmModalText"
      :submit-data="submitData"
      @submit="update($event)"
      @close="hideConfirmModal"
    />
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import {
  formatCustomDocumentValueSummary,
  getDocumentValueEditorConfig
} from '@/components/modals/documentValueEditors';
import DocumentValueModal from '@/components/modals/DocumentValueModal';
import Panel from '@/components/panel/Panel';
import Tooltip from '@/components/tooltip/Tooltip';
import { DocumentValueCodes } from '@/enums/documentValueCodes.enum';
import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { Successes } from '@/enums/successes.enum';
import { boolean } from '@/filters/boolean';
import { dateTime } from '@/filters/date';
import { documentValueTranslation } from '@/filters/documentValue';
import { confirmModalMixin } from '@/mixins/confirmModal';
import { modalFormMixin } from '@/mixins/modalForm';
import { tryParseInt } from '@/utils/number';

const messages = {
  getError: Errors.DOCUMENT_VALUE_CANNOT_GET,
  added: Successes.DOCUMENT_VALUE_ADDED,
  addError: Errors.DOCUMENT_VALUE_ADD_ERROR,
  updated: Successes.DOCUMENT_VALUE_UPDATED,
  updateError: Errors.DOCUMENT_VALUE_UPDATE_ERROR
};

// @vuese
// Wartości dokumentu
// @group Document
export default {
  components: { Panel, Tooltip, DocumentValueModal },
  mixins: [modalFormMixin('documentValue', messages), confirmModalMixin],
  data() {
    return {
      confirmModalText: 'Kliknij, aby potwierdzić zmianę wartości dokumentu.'
    };
  },
  computed: {
    ...mapState({
      values: state => state.document.documentValues.filter(documentValue => !!DocumentValueCodes[documentValue.code]),
      codes: state =>
        state.setting.settings[PublicSettings.PROCEDURE_EDITABLE_DOCUMENT_VALUE_CODES] &&
        JSON.parse(state.setting.settings[PublicSettings.PROCEDURE_EDITABLE_DOCUMENT_VALUE_CODES].value)
    })
  },
  methods: {
    boolean,
    dateTime,
    documentValueTranslation,
    isCustomValueCode(code) {
      return !!getDocumentValueEditorConfig(code);
    },
    isTextValueCode(code) {
      return code && code.indexOf('_TEXT') >= 0;
    },
    customValueSummary(value) {
      return formatCustomDocumentValueSummary(value.code, value.value) || '';
    },
    // @vuese
    // Odśwież listę po dodaniu
    afterAdd() {
      this.reloadList();
    },
    // @vuese
    // Odśwież listę po aktualizacji
    afterUpdate() {
      this.reloadList();
    },
    // @vuese
    // Odświeża listę
    reloadList() {
      this.$store.dispatch('document/getDocumentValues', tryParseInt(this.$route.params.documentId));
    }
  }
};
</script>
